module.exports = __webpack_public_path__ + "img/5.8a3c779d.webp";